import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";

const SearchBar = ({ onSearch, placeholder = "Rechercher un film, un cinéma..." }) => {
    const [query, setQuery] = useState("");

    // Debounce pour éviter trop de requêtes
    useEffect(() => {
        const timer = setTimeout(() => {
            onSearch(query);
        }, 300);

        return () => clearTimeout(timer);
    }, [query, onSearch]);

    const handleChange = (e) => {
        setQuery(e.target.value);
    };

    const handleClear = () => {
        setQuery("");
        onSearch("");
    };

    return (
        <div className="max-w-lg w-full mx-auto mb-3">
            <div className="relative flex items-center bg-gray-100 rounded-xl px-3 py-2">
                <FontAwesomeIcon
                    icon={faSearch}
                    className="text-gray-400 mr-2"
                />

                <input
                    type="text"
                    placeholder={placeholder}
                    value={query}
                    onChange={handleChange}
                    className="bg-transparent w-full outline-none text-gray-800 placeholder-gray-400 text-base"
                />

                {query && (
                    <button
                        onClick={handleClear}
                        className="absolute right-3 text-gray-400 hover:text-gray-600"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                )}
            </div>
        </div>
    );
};

export default SearchBar;